import React from 'react';
import { BlackRectangleProps } from "../../types/interfaces/auth"

export const AuthContainer: React.FC<BlackRectangleProps> = ({ children }) => {
    return (
        // Страница
        <div className="w-full min-h-dvh bg-white flex justify-center">
            {children}
        </div>
    )
}
